import { type SignupApplicationEntity } from './trackingEvents';

let currentGlobalSignupApplicationContext: SignupApplicationEntity | undefined;

const setGlobalSignupApplicationContext = (
  context?: SignupApplicationEntity
) => {
  currentGlobalSignupApplicationContext = context;
};

const getGlobalSignupApplicationContext = () => {
  return currentGlobalSignupApplicationContext;
};

export { getGlobalSignupApplicationContext, setGlobalSignupApplicationContext };
